// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'Ücretsiz deneme bugün sona erdi.',
  freeTimesLimitTitle: 'Yükselt',
  fileSizeLimitTitle: "Dosya boyutu ücretsiz sürümde 20MB'yi aşamaz.",
  freeImgCutoutTimesLimitTitle:
    "Arka plan kaldırma için bugünün deneme fırsatı tükendi, tüm premium özelliklere erişmek için lütfen Pro'ya yükseltin",
  total: 'Toplam',
  enterCode: 'Kodu girin',
  signUpToPurchaseBtn: 'Satın Almak için Kaydolun',
  goPurchseBtn: 'Satın Almaya Git',
  saveTips: "% {{num}}' ye Kadar Tasarruf Edin",
  discount: 'İndirim',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYear: '$3,75',
  billedMonth: '$29,99 Aylık Faturalandırılır',
  billedYear: '$179,99 Yıllık Faturalandırılır',
  monthly: 'Aylık',
  yearly: 'Yıllık',
  weekly: 'Haftalık',
  week: 'Hafta',
  AlreadySubscribe: 'Zaten abonesin?',
  vipTips1: 'Dosya boyutu sınırlamaları yok',
  vipTips2: 'İşlenen dosya sayısına sınırlama yok',
  vipTips3: 'Sınırsız olarak görüntü arka planlarını değiştirin',
  vipTips4: 'Tüm ücretsiz araçlara ve premium özelliklere erişim',
  purchaseTips: 'Otomatik olarak yenileyin ve istediğiniz zaman iptal edin.',
  tips: 'İpuçları:',
  promoCodeInvalidTips: 'Promosyon kodunuz geçersiz',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
